export default __webpack_public_path__ + "assets/e43247f63525f920c5b23ec092f98bed.png";